import React, { useState } from "react";
import PropTypes from "prop-types";
import { DataGrid } from "@mui/x-data-grid";
import MDBox from "components/MDBox";
import { IconButton, Chip } from "@mui/material";
import { Edit, Delete, Done as CheckCircle } from "components/icons";

const getCategoryColor = (category) => {
  const colors = {
    TECHNICAL: "primary",
    SOFT_SKILL: "secondary",
    DOMAIN: "info",
    TOOL: "warning",
    LANGUAGE: "success",
    CERTIFICATION: "error",
  };
  return colors[category] || "default";
};

export const SkillsDataGrid = ({ skills, isLoading, onEdit, onDelete, showActions = true }) => {
  const [pageSize, setPageSize] = useState(10);

  const columns = [
    ...(showActions ? [{
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      getActions: (params) => [
        <IconButton key="edit" onClick={() => onEdit(params.row)} color="primary" size="small">
          <Edit />
        </IconButton>,
        <IconButton key="delete" onClick={() => onDelete(params.row)} color="error" size="small">
          <Delete />
        </IconButton>,
      ],
    }] : []),
    { field: "id", headerName: "ID", width: 80 },
    { field: "skillName", headerName: "Skill Name", width: 200, flex: 1 },
    {
      field: "category",
      headerName: "Category",
      width: 150,
      renderCell: (params) => (
        <Chip
          label={params.value?.replace("_", " ")}
          color={getCategoryColor(params.value)}
          size="small"
        />
      ),
    },
    { field: "description", headerName: "Description", width: 300, flex: 1 },
    {
      field: "isActive",
      headerName: "Status",
      width: 100,
      renderCell: (params) => (
        <Chip
          icon={params.value ? <CheckCircle /> : null}
          label={params.value ? "Active" : "Inactive"}
          color={params.value ? "success" : "default"}
          size="small"
          variant={params.value ? "filled" : "outlined"}
        />
      ),
    },
  ];

  return (
    <MDBox pt={3} py={3} px={2} height={400}>
      <DataGrid
        rows={skills || []}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[5, 10, 20, 50]}
        loading={isLoading}
        disableSelectionOnClick
        getRowId={(row) => row.id}
      />
    </MDBox>
  );
};

SkillsDataGrid.propTypes = {
  skills: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  showActions: PropTypes.bool,
};

export default SkillsDataGrid;

